import _ from "lodash";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import RoleRequire from "../../helpers/auth/RoleRequire";

import { Button } from "../../ui/Button";
import { Input } from "../../ui/Input/Input";

import { ColumnDef } from "@tanstack/react-table";
import { base_reports } from "../../enums/reports";
import { useFetch } from "../../hooks/useFetch";
import { useTabsStore } from "../../stores/TabsStore";
import { SimpleDataTable } from "../../ui/DataTable/SimpleDataTable";
import { Popover, PopoverContent, PopoverTrigger } from "../../ui/Popover";

export default function ReportsGrid({onClose}:{onClose: () => void}) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const {setActiveReport} = useTabsStore();
  const [search, setSearch] = useState("");
  const [reportData, setReportData] = useState<{name: string, title: string}>();
  const [reportsList, setReportsList] = useState<{name: string, title: string}[]>();
  const [{ response: listPesponse, isLoading: listIsLoading }, doFetchListReport] = useFetch(
    `/directories/custom_data_storages`
  );
  const [{ response, isLoading }, doFetchReport] = useFetch(`/directories/custom_data_storages/${reportData?.name}`);

  // let id = tabs.length + 1;
  // const addTab = useTabsStore((store) => store.addTab);
  // const setActiveTab = useTabsStore((store) => store.setActiveTab);

  useEffect(() => {
    doFetchListReport();
  }, []);

  useEffect(() => {
    if (!listPesponse) return
    const list = listPesponse.data as unknown as { name: string; title: string }[];
    setReportsList(list);
  }, [listPesponse]);
  

  let nodes = reportsList?.map((report) => {
    return {
      id: report.name,
      name: report.name,
      title: report.title,
    };
  });



  // Сортировка по умолчанию
  nodes = _.sortBy(nodes, ["inventory_number"]);
  let data = { nodes };

  const handleSearch = (event: any) => {
    setSearch(event.target.value);
  };

  // Фильтрация через поиск
  data = {
    nodes: data.nodes?.filter(
      (item) =>
        item.title?.toLowerCase().includes(search.toLowerCase())
    ),
  };

  const columns: ColumnDef<any>[] = [
    {
      id: "id",
      accessorFn: (row) => `${row.name}`,
      header: t("report_title"),
      size: 1000,
      cell: (props) => props.row.original.title,
    }
  ];

  function selectReport(report: any) {
    setActiveReport({name: report.name, title: report.title})
    onClose()
    navigate("/analytics")
  }

  function addReport(report: any) {
    setActiveReport({name: report.type, title: report.name})
    onClose()
    navigate("/analytics")
  }

  return (
    <>
        <div className="flex flex-col w-full">
          <div className="flex flex-row w-full h-14 items-center gap-4 px-6 justify-between">
            <Input 
                className="h-8"
                placeholder={t("equipment_search")}
                onChange={handleSearch}
                value={search}
                autoComplete="off"
                width="100%" 
            />
              
            <RoleRequire role="maintainer">
              <Popover>
                <PopoverTrigger asChild>
                  <Button variant={"default"} size={"md"}>{t("add")}</Button>
                </PopoverTrigger>
                <PopoverContent className="p-2 w-48" align="end">
                  <div className="flex flex-col gap-1.5 ">
                    {base_reports.map((report) => (
                      <Button key={report.type} type="button" variant={"ghost"} size="datepicker" className="justify-start px-2 gap-2 " onClick={() => addReport(report)}>
                        <span>{report.icon}</span>
                        <span>{report.name}</span>
                      </Button>
                    ))}
                  </div>
                </PopoverContent>
              </Popover>
            </RoleRequire>
          </div>
        </div>

        {!data.nodes?.length ? ( // Заглушка для отсутствия данных при поиске
        <div className="flex w-full h-full justify-center items-center">
            {t("no_data")}
        </div>
        ) : (
          <SimpleDataTable data={data.nodes} columns={columns} onClickRow={selectReport}/>
        )}
  </>
  )
} 